<section class="content">
    <div class="container mt-3">
        <div class="row">
            <div class="col-md-5">
                <label class="form-label" for="selectedProject">Project</label>
                <select id="selectedProject" name="selectedProject" class="form-control" [(ngModel)]="selectedProject">
                    <option selected="selected" disabled="disabled" [ngValue]="null">--Select the Project--</option>
                    <option *ngFor="let project of projects" [ngValue]="project">{{project.name}}</option>
                </select>
            </div>
        </div>
        <div class="row mt-3" *ngIf="selectedProject">
            <div class="col">
                <button *ngIf="!running" type="button" class="btn btn-primary" (click)="run()">Download Results</button>
                <button *ngIf="running" type="button" class="btn btn-primary disabled" disabled="disabled">Downloading...</button>
            </div>
        </div>
    </div>
</section>
